import React from "react";
import { Container } from "react-bootstrap";
import { useParams, Navigate } from "react-router-dom";
import Particle from "./Particle";

const legalStyle = {
  padding: "50px 20px",
  textAlign: "left",
  backgroundColor: "rgba(255, 255, 255, 0.95)",
  borderRadius: "10px",
  marginTop: "120px",
  color: "#333",
};

const titleStyle = { textAlign: "center", marginBottom: "30px", color: "#2c3e50" };

function HangmanGoPrivacy() {
  return (
    <div className="legal-content" style={legalStyle}>
      <h1 style={titleStyle}>Privacy Policy for Hangman Go</h1>

      <p><strong>Effective Date: October 2025</strong></p>

      <h3>1) Scope</h3>
      <p>
        This Privacy Policy explains how Hangman Go ("App", "we", "us") processes information when you use the App.
        The App is designed for general audiences and can be used without creating an account.
      </p>

      <h3>2) Information We Process</h3>
      <h4>A. Information You Provide</h4>
      <ul>
        <li>No account or personal registration is required to play.</li>
        <li>In-App purchase actions are handled by Apple App Store or Google Play; we do not receive your full payment details.</li>
      </ul>

      <h4>B. Automatically Processed Information</h4>
      <ul>
        <li><strong>Local game data</strong>: progress, settings, language, inventory (stored on your device).</li>
        <li><strong>Purchase status & entitlements</strong>: limited purchase receipts / entitlement status (via store and/or RevenueCat) to unlock paid content.</li>
        <li><strong>Device & usage data</strong>: basic diagnostics, app version, performance data (used to improve stability and fix bugs).</li>
        <li><strong>Advertising identifiers</strong>: Apple IDFA / Google AAID and related signals processed by ad networks (e.g., Google AdMob) for ad delivery and, where permitted, personalization/frequency capping/fraud prevention.</li>
      </ul>

      <h3>3) Purposes of Processing</h3>
      <ul>
        <li>Provide core gameplay, save local progress, and restore purchases/entitlements.</li>
        <li>Process payments and subscriptions through platform stores.</li>
        <li>Show ads (including rewarded ads where available) and measure their performance.</li>
        <li>Maintain security, prevent fraud/abuse, and improve App performance.</li>
      </ul>

      <h3>4) Data Storage & Retention</h3>
      <ul>
        <li>Game progress is stored locally on your device. Deleting the App removes local data.</li>
        <li>Store/RevenueCat purchase records and limited analytics/diagnostic data may be retained as required for legitimate purposes (e.g., billing, compliance, debugging) and then deleted or anonymized.</li>
      </ul>

      <h3>5) Third-Party Services</h3>
      <p>We integrate third parties to operate the App. Their processing is governed by their own terms/policies:</p>
      <ul>
        <li><strong>Apple App Store / Google Play Billing</strong>: purchases, subscriptions, refunds, price changes.</li>
        <li><strong>RevenueCat</strong>: subscription & entitlement management (verifies active purchases to unlock content).</li>
        <li><strong>Google AdMob</strong>: ad serving, measurement, fraud prevention; may use device identifiers and related signals.</li>
      </ul>

      <h3>6) Children's Privacy</h3>
      <ul>
        <li>The App is family-friendly; we do not knowingly collect personal data from children.</li>
        <li>Where required by law or platform policy, personalized ads are limited or disabled for child users.</li>
        <li>Parents/guardians should supervise use and can manage device privacy/ad settings.</li>
      </ul>

      <h3>7) Your Choices</h3>
      <ul>
        <li><strong>Delete local data</strong>: uninstall the App.</li>
        <li><strong>Ads preferences</strong>: reset/limit Ad IDFA/AAID, "Limit Ad Tracking" / "Opt-out of Ads Personalization" in device settings.</li>
        <li><strong>Consent (EEA/UK where applicable)</strong>: you may be shown a consent prompt for ads; you can revisit choices in the App (if provided) or device settings.</li>
      </ul>

      <h3>8) Legal Bases & Your Rights</h3>
      <p>
        Where the GDPR applies, we rely on: performance of a contract (providing the App), legitimate interests
        (fraud prevention, analytics, service improvement), and consent (personalized ads where required).
        Under KVKK and/or GDPR (if applicable), you may have rights to access, correct, delete, restrict, object to processing,
        and data portability. You can exercise rights via the contact below; for purchases/refunds manage via the store.
      </p>

      <h3>9) Data Sharing</h3>
      <ul>
        <li>We do not sell your personal data.</li>
        <li>We share data only with service providers listed above, when required by law, or to protect our rights/users.</li>
      </ul>

      <h3>10) International Transfers</h3>
      <p>
        Third-party processors (e.g., AdMob, RevenueCat, Apple/Google) may process data on servers outside your country.
        Where required, safeguards (such as standard contractual clauses) may apply under their policies.
      </p>

      <h3>11) Security</h3>
      <p>
        We use reasonable technical and organizational measures appropriate to the nature of the data and our App.
        No method of transmission or storage is 100% secure.
      </p>

      <h3>12) Updates to This Policy</h3>
      <ul>
        <li>We may update this Policy from time to time to reflect changes in features or law.</li>
        <li>Material changes will be communicated in-App and/or via the store listing. Continued use means you accept the updated Policy.</li>
      </ul>

      <h3>13) Contact</h3>
      <p>For privacy questions or to exercise your rights, contact us:</p>
      <ul>
        <li>Email: <a href="mailto:sozdemircim@gmail.com">sozdemircim@gmail.com</a></li>
        <li>Website: <a href="https://www.suleymanozdemirci.com/project" target="_blank" rel="noreferrer">https://www.suleymanozdemirci.com/project</a></li>
        <li>We aim to respond within 7 business days.</li>
      </ul>

      <h3>14) Compliance Statement</h3>
      <ul>
        <li>Designed to align with Türkiye's KVKK.</li>
        <li>Intended to meet Google Play / Apple App Store disclosure expectations.</li>
        <li>Where applicable, aligned with GDPR/EEA children's privacy and advertising requirements.</li>
      </ul>

      <hr style={{ margin: "30px 0" }} />
      <p><strong>Last Updated: October 2025</strong></p>
    </div>
  );
}

function DotsplosionPrivacy() {
  return (
    <div className="legal-content" style={legalStyle}>
      <h1 style={titleStyle}>Privacy Policy for Dotsplosion</h1>

      <p><strong>Effective Date: March 2026</strong></p>

      <h3>1) Scope</h3>
      <p>
        This Privacy Policy explains how Dotsplosion ("App", "we", "us") processes information when you use the App.
        The App is a multiplayer chain-reaction game available on iOS and Android, featuring online matchmaking, friend rooms, and ranked play.
      </p>

      <h3>2) Information We Process</h3>
      <h4>A. Information You Provide</h4>
      <ul>
        <li>No separate account registration is required. Authentication is handled via your Apple ID or Google account through the platform.</li>
        <li>In-App purchase actions are handled by Apple App Store or Google Play; we do not receive your full payment details.</li>
      </ul>

      <h4>B. Automatically Processed Information</h4>
      <ul>
        <li><strong>Local game data</strong>: progress, settings, powerup inventory (stored on your device).</li>
        <li><strong>Online game data</strong>: match results, ELO rating, leaderboard position, and friend room activity (processed on our servers to enable multiplayer features).</li>
        <li><strong>Device & usage data</strong>: basic diagnostics, app version, performance data (used to improve stability and fix bugs).</li>
        <li><strong>Advertising identifiers</strong>: Apple IDFA / Google AAID and related signals processed by ad networks (e.g., Google AdMob) for ad delivery and, where permitted, personalization/frequency capping/fraud prevention.</li>
      </ul>

      <h3>3) Purposes of Processing</h3>
      <ul>
        <li>Provide core gameplay, online matchmaking, ranked ladder, and friend room features.</li>
        <li>Store match results and ELO ratings to enable competitive play and leaderboards.</li>
        <li>Process payments through platform stores.</li>
        <li>Show ads (including rewarded ads where available) and measure their performance.</li>
        <li>Maintain security, prevent cheating/fraud, and improve App performance.</li>
      </ul>

      <h3>4) Data Storage & Retention</h3>
      <ul>
        <li>Local game data is stored on your device. Deleting the App removes local data.</li>
        <li>Online data (match history, ELO rating, leaderboard position) is stored on our servers for as long as necessary to provide the service. You may request deletion via the contact below.</li>
        <li>Purchase records and limited analytics/diagnostic data may be retained as required for legitimate purposes.</li>
      </ul>

      <h3>5) Third-Party Services</h3>
      <p>We integrate third parties to operate the App. Their processing is governed by their own terms/policies:</p>
      <ul>
        <li><strong>Apple App Store / Google Play Billing</strong>: purchases, refunds, price changes.</li>
        <li><strong>Google AdMob</strong>: ad serving, measurement, fraud prevention; may use device identifiers and related signals.</li>
        <li><strong>Firebase</strong>: backend services including real-time matchmaking and data synchronization.</li>
      </ul>

      <h3>6) Children's Privacy</h3>
      <p>
        The App may be used by children under the age of 13. We take children's privacy seriously
        and comply with the Children's Online Privacy Protection Act (COPPA), GDPR provisions for minors,
        and Türkiye's KVKK.
      </p>
      <ul>
        <li>We do <strong>not</strong> knowingly collect, store, or process personal information from children under 13 (or the applicable age of consent in your jurisdiction).</li>
        <li>The App does not require account creation, profile information, or any personal data entry from users of any age.</li>
        <li>Online features (matchmaking, leaderboards) use anonymous or platform-generated identifiers only; no child-identifiable information is collected by us.</li>
        <li>Personalized advertising is <strong>disabled</strong> for all users identified as children by the platform. Only contextual or limited ads are shown where permitted.</li>
        <li>We do not share any child's data with third parties for marketing or promotional purposes.</li>
        <li>If you are a parent or guardian and believe your child has provided personal information through the App, please contact us at <a href="mailto:sozdemircim@gmail.com">sozdemircim@gmail.com</a> so we can promptly delete such information.</li>
        <li>Parents and guardians are encouraged to supervise their children's use of the App and can manage privacy, ad tracking, and in-app purchase settings through their device's parental controls.</li>
      </ul>

      <h3>7) Your Choices</h3>
      <ul>
        <li><strong>Delete local data</strong>: uninstall the App.</li>
        <li><strong>Delete online data</strong>: contact us via email to request deletion of your match history and rating data.</li>
        <li><strong>Ads preferences</strong>: reset/limit Ad IDFA/AAID, "Limit Ad Tracking" / "Opt-out of Ads Personalization" in device settings.</li>
        <li><strong>Consent (EEA/UK where applicable)</strong>: you may be shown a consent prompt for ads; you can revisit choices in the App (if provided) or device settings.</li>
      </ul>

      <h3>8) Legal Bases & Your Rights</h3>
      <p>
        Where the GDPR applies, we rely on: performance of a contract (providing the App and multiplayer services), legitimate interests
        (fraud/cheat prevention, analytics, service improvement), and consent (personalized ads where required).
        Under KVKK and/or GDPR (if applicable), you may have rights to access, correct, delete, restrict, object to processing,
        and data portability. You can exercise rights via the contact below.
      </p>

      <h3>9) Data Sharing</h3>
      <ul>
        <li>We do not sell your personal data.</li>
        <li>Your display name, ELO rating, and match results may be visible to other players on leaderboards and in match lobbies.</li>
        <li>We share data only with service providers listed above, when required by law, or to protect our rights/users.</li>
      </ul>

      <h3>10) International Transfers</h3>
      <p>
        Third-party processors (e.g., AdMob, Firebase, Apple/Google) may process data on servers outside your country.
        Where required, safeguards (such as standard contractual clauses) may apply under their policies.
      </p>

      <h3>11) Security</h3>
      <p>
        We use reasonable technical and organizational measures appropriate to the nature of the data and our App.
        No method of transmission or storage is 100% secure.
      </p>

      <h3>12) Updates to This Policy</h3>
      <ul>
        <li>We may update this Policy from time to time to reflect changes in features or law.</li>
        <li>Material changes will be communicated in-App and/or via the store listing. Continued use means you accept the updated Policy.</li>
      </ul>

      <h3>13) Contact</h3>
      <p>For privacy questions or to exercise your rights, contact us:</p>
      <ul>
        <li>Email: <a href="mailto:sozdemircim@gmail.com">sozdemircim@gmail.com</a></li>
        <li>Website: <a href="https://www.suleymanozdemirci.com/project" target="_blank" rel="noreferrer">https://www.suleymanozdemirci.com/project</a></li>
        <li>We aim to respond within 7 business days.</li>
      </ul>

      <h3>14) Compliance Statement</h3>
      <ul>
        <li>Designed to align with Türkiye's KVKK.</li>
        <li>Intended to meet Google Play / Apple App Store disclosure expectations.</li>
        <li>Where applicable, aligned with GDPR/EEA children's privacy and advertising requirements.</li>
      </ul>

      <hr style={{ margin: "30px 0" }} />
      <p><strong>Last Updated: March 2026</strong></p>
    </div>
  );
}

function WordPopPrivacy() {
  return (
    <div className="legal-content" style={legalStyle}>
      <h1 style={titleStyle}>Privacy Policy for WordPop Blast</h1>

      <p><strong>Effective Date: April 2025</strong></p>

      <h3>1) Scope</h3>
      <p>
        This Privacy Policy explains how WordPop Blast ("App", "we", "us") processes information when you use the App.
        The App is a word puzzle game available on iOS, featuring Game Center leaderboards.
      </p>

      <h3>2) Information We Process</h3>
      <h4>A. Information You Provide</h4>
      <ul>
        <li>No account or personal registration is required to play.</li>
        <li>In-App purchase actions are handled by Apple App Store; we do not receive your full payment details.</li>
      </ul>

      <h4>B. Automatically Processed Information</h4>
      <ul>
        <li><strong>Local game data</strong>: progress, settings, level completion (stored on your device).</li>
        <li><strong>Game Center data</strong>: your Game Center display name and scores may be shared with Apple Game Center for leaderboard functionality. This data is managed by Apple.</li>
        <li><strong>Device & usage data</strong>: basic diagnostics, app version, performance data (used to improve stability and fix bugs).</li>
        <li><strong>Advertising identifiers</strong>: Apple IDFA and related signals processed by ad networks (e.g., Google AdMob) for ad delivery and, where permitted, personalization/frequency capping/fraud prevention.</li>
      </ul>

      <h3>3) Purposes of Processing</h3>
      <ul>
        <li>Provide core gameplay, save local progress, and manage Game Center leaderboards.</li>
        <li>Process payments through Apple App Store.</li>
        <li>Show ads (including rewarded ads where available) and measure their performance.</li>
        <li>Maintain security, prevent fraud/abuse, and improve App performance.</li>
      </ul>

      <h3>4) Data Storage & Retention</h3>
      <ul>
        <li>Game progress is stored locally on your device. Deleting the App removes local data.</li>
        <li>Game Center data is managed by Apple according to their retention policies.</li>
        <li>Limited analytics/diagnostic data may be retained as required for legitimate purposes.</li>
      </ul>

      <h3>5) Third-Party Services</h3>
      <p>We integrate third parties to operate the App. Their processing is governed by their own terms/policies:</p>
      <ul>
        <li><strong>Apple App Store</strong>: purchases, refunds.</li>
        <li><strong>Apple Game Center</strong>: leaderboards and achievements. Your display name and scores may be visible to other players.</li>
        <li><strong>Google AdMob</strong>: ad serving, measurement, fraud prevention; may use device identifiers and related signals.</li>
        <li><strong>Firebase Analytics</strong>: anonymous usage analytics to improve the App.</li>
      </ul>

      <h3>6) Children's Privacy</h3>
      <ul>
        <li>The App is family-friendly; we do not knowingly collect personal data from children under 13.</li>
        <li>Where required by law or platform policy, personalized ads are limited or disabled for child users.</li>
        <li>Parents/guardians should supervise use and can manage device privacy/ad settings.</li>
      </ul>

      <h3>7) Your Choices</h3>
      <ul>
        <li><strong>Delete local data</strong>: uninstall the App.</li>
        <li><strong>Ads preferences</strong>: reset/limit Ad IDFA, "Limit Ad Tracking" in device settings.</li>
        <li><strong>Game Center</strong>: manage your Game Center profile and visibility in iOS settings.</li>
        <li><strong>Consent (EEA/UK where applicable)</strong>: you may be shown a consent prompt for ads; you can revisit choices in the App (if provided) or device settings.</li>
      </ul>

      <h3>8) Legal Bases & Your Rights</h3>
      <p>
        Where the GDPR applies, we rely on: performance of a contract (providing the App), legitimate interests
        (analytics, service improvement), and consent (personalized ads where required).
        Under KVKK and/or GDPR (if applicable), you may have rights to access, correct, delete, restrict, object to processing,
        and data portability. You can exercise rights via the contact below.
      </p>

      <h3>9) Data Sharing</h3>
      <ul>
        <li>We do not sell your personal data.</li>
        <li>We share data only with service providers listed above, when required by law, or to protect our rights/users.</li>
      </ul>

      <h3>10) International Transfers</h3>
      <p>
        Third-party processors (e.g., AdMob, Firebase, Apple) may process data on servers outside your country.
        Where required, safeguards (such as standard contractual clauses) may apply under their policies.
      </p>

      <h3>11) Security</h3>
      <p>
        We use reasonable technical and organizational measures appropriate to the nature of the data and our App.
        No method of transmission or storage is 100% secure.
      </p>

      <h3>12) Updates to This Policy</h3>
      <ul>
        <li>We may update this Policy from time to time to reflect changes in features or law.</li>
        <li>Material changes will be communicated in-App and/or via the store listing. Continued use means you accept the updated Policy.</li>
      </ul>

      <h3>13) Contact</h3>
      <p>For privacy questions or to exercise your rights, contact us:</p>
      <ul>
        <li>Email: <a href="mailto:sozdemircim@gmail.com">sozdemircim@gmail.com</a></li>
        <li>Website: <a href="https://www.suleymanozdemirci.com/project" target="_blank" rel="noreferrer">https://www.suleymanozdemirci.com/project</a></li>
        <li>We aim to respond within 7 business days.</li>
      </ul>

      <h3>14) Compliance Statement</h3>
      <ul>
        <li>Designed to align with Türkiye's KVKK.</li>
        <li>Intended to meet Apple App Store disclosure expectations.</li>
        <li>Where applicable, aligned with GDPR/EEA children's privacy and advertising requirements.</li>
      </ul>

      <hr style={{ margin: "30px 0" }} />
      <p><strong>Last Updated: March 2026</strong></p>
    </div>
  );
}

function OneToFiftyPrivacy() {
  return (
    <div className="legal-content" style={legalStyle}>
      <h1 style={titleStyle}>Privacy Policy for 1to50 Race</h1>

      <p><strong>Effective Date: April 2025</strong></p>

      <h3>1) Scope</h3>
      <p>
        This Privacy Policy explains how 1to50 Race ("App", "we", "us") processes information when you use the App.
        The App is a simple number-tapping speed game available on iOS. No account creation is required.
      </p>

      <h3>2) Information We Process</h3>
      <h4>A. Information You Provide</h4>
      <ul>
        <li>No account or personal registration is required to play.</li>
      </ul>

      <h4>B. Automatically Processed Information</h4>
      <ul>
        <li><strong>Local game data</strong>: best times and settings (stored on your device).</li>
        <li><strong>Device & usage data</strong>: basic diagnostics, app version, performance data (used to improve stability and fix bugs).</li>
        <li><strong>Advertising identifiers</strong>: Apple IDFA and related signals processed by ad networks (e.g., Google AdMob) for ad delivery and, where permitted, personalization/frequency capping/fraud prevention.</li>
      </ul>

      <h3>3) Purposes of Processing</h3>
      <ul>
        <li>Provide core gameplay and save local progress.</li>
        <li>Show ads and measure their performance.</li>
        <li>Maintain security and improve App performance.</li>
      </ul>

      <h3>4) Data Storage & Retention</h3>
      <ul>
        <li>Game progress is stored locally on your device. Deleting the App removes local data.</li>
        <li>Limited analytics/diagnostic data may be retained as required for legitimate purposes.</li>
      </ul>

      <h3>5) Third-Party Services</h3>
      <p>We integrate third parties to operate the App. Their processing is governed by their own terms/policies:</p>
      <ul>
        <li><strong>Apple App Store</strong>: app distribution.</li>
        <li><strong>Google AdMob</strong>: ad serving, measurement, fraud prevention; may use device identifiers and related signals.</li>
      </ul>

      <h3>6) Children's Privacy</h3>
      <ul>
        <li>The App is family-friendly; we do not knowingly collect personal data from children under 13.</li>
        <li>Where required by law or platform policy, personalized ads are limited or disabled for child users.</li>
        <li>Parents/guardians should supervise use and can manage device privacy/ad settings.</li>
      </ul>

      <h3>7) Your Choices</h3>
      <ul>
        <li><strong>Delete local data</strong>: uninstall the App.</li>
        <li><strong>Ads preferences</strong>: reset/limit Ad IDFA, "Limit Ad Tracking" in device settings.</li>
        <li><strong>Consent (EEA/UK where applicable)</strong>: you may be shown a consent prompt for ads; you can revisit choices in the App (if provided) or device settings.</li>
      </ul>

      <h3>8) Legal Bases & Your Rights</h3>
      <p>
        Where the GDPR applies, we rely on: performance of a contract (providing the App), legitimate interests
        (analytics, service improvement), and consent (personalized ads where required).
        Under KVKK and/or GDPR (if applicable), you may have rights to access, correct, delete, restrict, object to processing,
        and data portability. You can exercise rights via the contact below.
      </p>

      <h3>9) Data Sharing</h3>
      <ul>
        <li>We do not sell your personal data.</li>
        <li>We share data only with service providers listed above, when required by law, or to protect our rights/users.</li>
      </ul>

      <h3>10) International Transfers</h3>
      <p>
        Third-party processors (e.g., AdMob, Apple) may process data on servers outside your country.
        Where required, safeguards (such as standard contractual clauses) may apply under their policies.
      </p>

      <h3>11) Security</h3>
      <p>
        We use reasonable technical and organizational measures appropriate to the nature of the data and our App.
        No method of transmission or storage is 100% secure.
      </p>

      <h3>12) Updates to This Policy</h3>
      <ul>
        <li>We may update this Policy from time to time to reflect changes in features or law.</li>
        <li>Material changes will be communicated in-App and/or via the store listing. Continued use means you accept the updated Policy.</li>
      </ul>

      <h3>13) Contact</h3>
      <p>For privacy questions or to exercise your rights, contact us:</p>
      <ul>
        <li>Email: <a href="mailto:sozdemircim@gmail.com">sozdemircim@gmail.com</a></li>
        <li>Website: <a href="https://www.suleymanozdemirci.com/project" target="_blank" rel="noreferrer">https://www.suleymanozdemirci.com/project</a></li>
        <li>We aim to respond within 7 business days.</li>
      </ul>

      <h3>14) Compliance Statement</h3>
      <ul>
        <li>Designed to align with Türkiye's KVKK.</li>
        <li>Intended to meet Apple App Store disclosure expectations.</li>
        <li>Where applicable, aligned with GDPR/EEA children's privacy and advertising requirements.</li>
      </ul>

      <hr style={{ margin: "30px 0" }} />
      <p><strong>Last Updated: March 2026</strong></p>
    </div>
  );
}

const privacyComponents = {
  hangmango: HangmanGoPrivacy,
  dotsplosion: DotsplosionPrivacy,
  wordpop: WordPopPrivacy,
  "1to50": OneToFiftyPrivacy,
};

function PrivacyPolicy() {
  const { game } = useParams();

  const ContentComponent = game ? privacyComponents[game] : null;

  if (!ContentComponent) {
    return <Navigate to="/project" />;
  }

  return (
    <Container fluid className="about-section">
      <Particle />
      <Container>
        <ContentComponent />
      </Container>
    </Container>
  );
}

export default PrivacyPolicy;
